import styled from 'styled-components';

const FlexContainer = styled.div<{marginTop?: string}>`
  margin-top: ${props => props.marginTop ?? '1rem'};
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export default FlexContainer;
